/* eslint-disable no-nested-ternary */
import { fetch } from 'http-common';

import { ListType } from 'types/api/api.type';
import { Order } from 'types/api/orders.type';

type OrdersDataList = Omit<ListType, 'content'> & { content: Order[] };

class OrdersDataService {
  private http = fetch();

  private ep = '/v1/orders';

  public getOrders(
    page?: number,
    size?: number,
    sorting?: { id: string; desc: boolean },
    dateStart?: string,
    dateEnd?: string,
    zone?: string,
    status?: string,
    customerCode?: string
  ) {
    return this.http.get<OrdersDataList>(`${this.ep}`, {
      params: {
        page: page || 0,
        size: size || 10,
        sort: sorting
          ? `${
              sorting.id === 'createdAt'
                ? 'orderId.createdAt'
                : sorting.id === 'id'
                ? 'orderId.orderNumber'
                : sorting.id === 'zone'
                ? 'customerCode'
                : sorting.id === 'code'
                ? 'customerCode'
                : sorting.id
            },${sorting.desc ? 'desc' : 'asc'}, `
          : undefined,
        zone,
        status,
        dateStart,
        dateEnd,
        customerCode,
      },
    });
  }

  public post(season: string, zone: string, warehouse: string, customerCode: string) {
    return this.http.post(this.ep, {
      season,
      zone,
      warehouseInternalCode: warehouse,
      customerCode,
    });
  }

  public getOrder(id: string) {
    return this.http.get(`${this.ep}/${id}`);
  }

  public delete(orderId: string) {
    return this.http.delete(`${this.ep}/${orderId}`);
  }

  public restore(orderId: string) {
    return this.http.patch(`${this.ep}/${orderId}/restore`);
  }
}

const ordersDataService = new OrdersDataService();

export { ordersDataService };
